import _ from 'lodash'

export const REGIONS = [
  {
    name: 'World',
    code: 'world',
  },
  {
    name: 'CEE',
    label: 'CEE',
    full_name: 'Central-East Europe',
    code: 'cee',
  },
  {
    name: 'Europe',
    code: 'europe',
  },
  {
    full_name: 'European Union',
    name: 'EU',
    code: 'eu',
  },
]

export const REGIONS_CHOICES = REGIONS.map((region) => ({
  value: region.code,
  label: region.label || region.full_name || region.name,
}))

export const regionsByCode = _.keyBy(REGIONS, 'code')

export function regionName(code) {
  const region = regionsByCode[code]
  return region.name
}
